module.exports = __webpack_public_path__ + "img/row.df12af80.png";